import React from 'react'
import { CMSOpportunityDetailsImagesType } from '../../../lib/types'

const CMSOpportunityImages = ({
  opportunityImages,
}: {
  opportunityImages?: CMSOpportunityDetailsImagesType
}) => {
  return (
    <section className='opportunity-cms-section-image-list' data-testid='cms-opportunity-images'>
      {opportunityImages?.images?.map((url, idx) => (
        <img
          key={`opportunity-image-${idx}`}
          src={url}
          alt={`Image ${idx + 1}`}
          className={`width-100percent ${idx === 0 ? '' : 'mt-12'}`}
        />
      ))}
    </section>
  )
}

export { CMSOpportunityImages }
